import { useUrlToast } from "@/hooks/use-url-toast"
import { useTheme } from "next-themes"
import { Toaster as Sonner, ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  useUrlToast()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group z-50"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)"
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
